const DEFAULT_STICKER_HEIGHT = 25

export default class StickerSettings {
    constructor(htmlId, railNumber = "", deviceId = "") {
        if (!htmlId) {
            throw new Error("Undefined HTML ID");
        }
        this.railNumber = parseInt(railNumber);
        this.deviceId = deviceId;
        this.htmlId = htmlId;
        this.registerStickerSettingsCLick();
        this.registerColorClick();
        this.registerFontFamilyClick();
        this.registerTextAlignClick();
    }

    render = (config) => {
        const stickerSettingsHtml = RENDER.render_sticker_settings(config);
        $(this.htmlId).html(stickerSettingsHtml);
        this.renderSliders();
        setTimeout(this.registerStickerSettingsEvents, 100)
        this.renderColorPicker();
        this.renderPreview();
    }

    renderSliders = () => {
        this.renderStickerHeightSlider();
        this.renderIconsScaleSlider(scale);
        this.renderFontSizeSlider();
    }

    getId = () => {
        let id = this.deviceId != "" ? this.deviceId : (this.railNumber !== "" ? this.railNumber : "");
        if (typeof (id.length) === "undefined" && !Number.isInteger(id)) {
            return ""
        }

        return id;
    }

    registerStickerSettingsCLick = () => {
        const concreteId = this.getId();
        const selector = `${this.htmlId} input[data-setting]`;
        $(document).off("change", selector).on("change", selector, (e) => {
            console.log("sticker setting click");
            const [param, val] = [$(e.currentTarget).data('setting'), $(e.currentTarget).is(':checked')];
            STORAGE.setSetting(`${param}${concreteId}`, val);
            this.renderPreview();
        })
    }

    registerColorClick = () => {
        $('body').off('click', `${this.htmlId} div.micro_color span[data-action="paint"]`).on('click', `${this.htmlId} div.micro_color span[data-action="paint"]`, (e) => {
            const concreteId = this.getId();
            STORAGE.setSetting(`stickerColor${concreteId}`, $(e.target).data('color'));
            this.renderPreview();
        })

    }

    renderStickerHeightSlider = () => {
        if (this.stickerHeightSlider) return;

        const val = REUSE.StickerSettings.getStickerSettings(this.railNumber, this.deviceId, 'stickerHeight')
        $(`${this.htmlId} #stickerHeight`).html(val)
        this.stickerHeightSlider = new Slider(`${this.htmlId} input#stickerHeightSlider`, {
            formatter: (val => {
                return val + 'мм';
            })
        })

        this.stickerHeightSlider.setValue(val);
        this.stickerHeightSlider.on('change', () => {
            const stickerHeight = this.stickerHeightSlider.getValue();
            const id = this.getId();
            // console.log("****", id);

            $(`${this.htmlId} #stickerHeight`).html(stickerHeight)

            STORAGE.setSetting(`stickerHeight${id}`, stickerHeight);
            this.renderPreview();
        });
    }

    renderIconsScaleSlider = (scale = false) => {
        if (this.iconsScaleSlider) return;
        const val = REUSE.StickerSettings.getStickerSettings(this.railNumber, this.deviceId, 'iconsScale')
        $(`${this.htmlId} #iconsScale`).html(val)


        this.iconsScaleSlider = new Slider(`${this.htmlId} input#iconsScaleSlider`, {
            formatter: (val => {
                return val + '%';
            })
        })

        this.iconsScaleSlider.setValue(val);

        this.iconsScaleSlider.on('change', () => {
            const iconsScale = this.iconsScaleSlider.getValue();

            $(`${this.htmlId} #iconsScale`).html(iconsScale)
            STORAGE.setSetting(`iconsScale${this.getId()}`, iconsScale);
            this.renderPreview();
        });
    }

    renderFontSizeSlider = () => {
        if (this.fontSizeSlider) return;
        const val = REUSE.StickerSettings.getStickerSettings(this.railNumber, this.deviceId, 'fontSize')
        $(`${this.htmlId} #fontSize`).html(val)

        this.fontSizeSlider = new Slider(`${this.htmlId} input#fontSizeSlider`, {
            formatter: (val => {
                return val;
            })
        })
        this.fontSizeSlider.setValue(val);

        this.fontSizeSlider.on('change', () => {
            const fontSize = this.fontSizeSlider.getValue();
            $(`${this.htmlId} #fontSize`).html(fontSize)
            STORAGE.setSetting(`fontSize${this.getId()}`, fontSize);
            this.renderPreview();
        });
    }

    registerFontFamilyClick = () => {
        $('body').off('click', `${this.htmlId} input[name=fontSelector]`).on('click', `${this.htmlId} input[name=fontSelector]`, (e) => {
            const fontFamily = $(e.currentTarget).val();
            const concreteId = this.getId();
            STORAGE.setSetting(`fontFamily${concreteId}`, fontFamily);
            this.renderPreview();
        })
    }

    registerTextAlignClick = () => {
        $('body').off('click', `${this.htmlId} input[name=textAlignSelector]`).on('click', `${this.htmlId} input[name=textAlignSelector]`, (e) => {
            const textAlign = $(e.currentTarget).val();
            const concreteId = this.getId();
            STORAGE.setSetting(`stickerTextAlign${concreteId}`, textAlign);
            this.renderPreview();
        })
    }

    renderPreview = () => {
        const baseWidth = REUSE.StickerSettings.getStickerSettings(this.railNumber, this.deviceId, 'baseWidth')
        const stickerPreview = $(`${this.htmlId} #stickerPreview`);
        stickerPreview.html("");
        const widths = [baseWidth, Math.round(baseWidth * 2 * 100) / 100, Math.round(baseWidth * 3 * 100) / 100];

        const mockDevice = {
            icon: 'plug',
            color: ['pink', 'blue_bottom'],
            number: 42,
            numberBottom: 'Гостиная',
            text: 'Устройство защиты от дугового пробоя,  30мА тип AC F204 4 полюса 63А',
        }

        const settings = STORAGE.settings;
        ['stickerNumberTop', 'stickerIcon', 'stickerText', 'stickerInvert'].forEach(param => {
            param = `${param}${this.getId()}`
            $(`${this.htmlId} input[data-setting="${param}"]`).prop('checked', settings[param] == true);
        })

        widths.forEach(width => {
            mockDevice.width = width;
            mockDevice.numberTop = width + 'мм';
            const config = REUSE.StickerSettings.getStickerSettings(this.railNumber, this.deviceId)

            const sticker = RENDER.render_sticker(
                mockDevice,
                config
            )
            stickerPreview.append(sticker.context)
        })
    }

    renderColorPicker = () => {
        let res = ''
        Object.keys(COLORS_RGB).forEach(key => {
            let color = COLORS_RGB[key]
            res += `<span data-action="paint" data-color="#${color}" class="${key}"></span>`
        })

        $(`${this.htmlId} div.micro_color`).html(res)
    }

    static getStickerSettings = (railNumber, deviceId = false, specificSetting = null) => {
        let res = {};
        let list = []
        if (specificSetting) {
            list.push(specificSetting)
        } else {
            list = [
                'stickerHeight',
                'stickerColor',
                'iconsScale',
                'stickerNumberTop',
                'stickerNumberBottom',
                'stickerIcon',
                'stickerText',
                'stickerTextAlign',
                'stickerInvert',
                'stickerVerticalText',
                'fontSize',
                'fontFamily'
            ]
        }

        const hasDeviceId = deviceId !== false && deviceId !== null && deviceId !== undefined && `${deviceId}`.length > 0;
        list.forEach(param => {
            if (hasDeviceId && typeof STORAGE.settings[`${param}${deviceId}`] !== "undefined") {
                res[param] = STORAGE.settings[`${param}${deviceId}`]
            }
            else if (railNumber !== false && railNumber !== null && railNumber !== undefined && railNumber !== ''
                && typeof STORAGE.settings[`${param}${railNumber}`] !== "undefined") {
                res[param] = STORAGE.settings[`${param}${railNumber}`]
            }
            else {
                if (typeof STORAGE.settings[`${param}`] != "undefined") {
                    res[param] = STORAGE.settings[`${param}`]
                }
                else {
                    res[param] = STORAGE.defaultSettings[`${param}`]
                }
            }

            // Normalize checkbox-like flags (Firebase/history may store "true"/"false" strings)
            if (typeof res[param] === 'string' && (res[param] === 'true' || res[param] === 'false')) {
                res[param] = res[param] === 'true';
            }
        })

        if (specificSetting) {
            return res[specificSetting]
        }

        return res;
    }
}
